module.exports = __webpack_public_path__ + "assets/img/suihang.8883d617.png";